"use client";

import { deferredIsland } from "@/components/ui/deferred-island";

export const DeferredNewVersionPrompt = deferredIsland(
  () =>
    import("@/components/app-update/new-version-prompt").then(
      (module) => module.NewVersionPrompt,
    ),
  "new-version-prompt",
);

export const DeferredAuthEventTracker = deferredIsland(
  () =>
    import("@/components/analytics/auth-event-tracker").then(
      (module) => module.AuthEventTracker,
    ),
  "auth-event-tracker",
);
